import { currencyFormatter } from "../../common/helpers/currency";
import { FormRowRaw } from "../forms/FormRowRaw";
import styles from "./Reconciliation.module.scss";

interface Props {
    cashIn: number;
    cashOut: number;
    net: number;
}

export const ReconciliationTransactionsSummary: React.FC<Props> = ({
    cashIn,
    cashOut,
    net,
}) => (
    <div className={styles.balanceStats}>
        <div className="input-group">
            <FormRowRaw
                label="Cash in"
                value={currencyFormatter.format(cashIn)}
                size="xs"
                disabled
            />
            <FormRowRaw
                label="Cash out"
                value={currencyFormatter.format(cashOut)}
                size="xs"
                disabled
            />
        </div>
        <FormRowRaw
            label="Net"
            value={currencyFormatter.format(net)}
            size="xs"
            disabled
        />
    </div>
);
